module.exports = __webpack_public_path__ + "img/waving_hand.0f24771d.gif";